class RemoveFilterActionHandler {
}
export default RemoveFilterActionHandler;
